import { render, staticRenderFns } from "./ModalPersonaRol.vue?vue&type=template&id=e8e1b7a4&"
import script from "./ModalPersonaRol.vue?vue&type=script&lang=js&"
export * from "./ModalPersonaRol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports